// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","testResultRow":"F3_gQo2200yAMwmAOu0bU","testResultColumn":"_1m5C0ZVSO_KrF8NrzLyVGz"};